<template lang='pug'>
    v-card.overflow-hidden.elevation-2.mb-5
        crud-form( disabled :editable='false' submit-text='guardar oferta' ref='form' v-bind='formProps' @calculate='calculate' @submitForm='submit' )
            crud-data-table( no-actions no-export no-search-box no-visual-help v-bind='tableProps' slot='appendContent' )
</template>

<script>
//
import { mapActions } from 'vuex'
//import { CrudFieldset, CrudFormLayout, CrudFormSectionLayout, ModelDataTable } from '@/components/reusable_components/next'
import { CrudForm, CrudDataTable } from '@/components/reusable_components'
import OfferService from '@/services/api/offer'
import BranchOfficeService from '@/services/api/branchOffice'
import ProductService from '@/services/api/product'
import saleUtils from '@/services/SaleUtils'
//
import GeneralFields from './partials/fields/general'
import ProductHeaders from './partials/headers/product'
// import ItemDTService from '@/services/api/item/ItemDTService'
//
export default {
    components: {
        'crud-form': CrudForm,
        'crud-data-table': CrudDataTable,
    },
    computed: {
        /**
         *
         */
        dialogTableProps() {
            return {
                headers: ProductHeaders,
                service: ProductService,
            }
        },

        /**
         *
         */
        formProps() {
            return {
                fields: this.formFields,
            }
        },

        /**
         *
         */
        tableProps() {
            return {
                headers: ProductHeaders,
                service: this.service,
            }
        },
    },
    data() {
        return {
            dialog: false,
            formFields: JSON.parse(JSON.stringify(GeneralFields)),
            products: [],
            service: {
                dtFetchData: () => ({
                    data: [],
                }),
            },
        }
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        /**
         *
         */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        calculate(event) {
            switch (event.field) {
                case 'branchOfficeId':
                case 'discount':
                    this.products = [
                        ...this.products.map(this.mapSelectedToProduct),
                    ]
                    this.service = {
                        dtFetchData: () => ({
                            data: this.products,
                        }),
                    }
                    break
            }
        },

        /**
         *
         */
        findById(id) {
            return function(item) {
                return item.id === id
            }
        },

        /**
         *
         */
        mapProduct(product) {
            return {
                id: product.id,
                offer_price: product.virtual_offer_price,
            }
        },

        /**
         *
         */
        mapSelectedToProduct(product) {
            const salePrice =
                    (product.sale_prices.find(this.findById) || {})
                        .sale_price || 0,
                offerDiscount = Number(this.$refs.form.vmodels.discount),
                offerPrice = saleUtils.priceWithDiscount(
                    salePrice,
                    offerDiscount
                )

            return {
                ...product,
                sale_price_by_branch_office: salePrice,
                virtual_offer_price: offerPrice,
            }
        },

        /**
         *
         */
        async reset() {
            const offer = await OfferService.fetchById(this.$route.params.id)

            this.formFields[0].value = offer.g_branch_office_id
            this.formFields[1].value = offer.name
            this.formFields[2].value = offer.init_datetime
            this.formFields[3].value = offer.finish_datetime
            //this.formFields[ 4 ].value = ( offer.offer_price - offer.wh_product.sale_price ) / offer.wh_product.sale_price

            this.formFields[0].options.data = await BranchOfficeService.fetchAll()

            this.formFields = [...this.formFields]
            this.products = [
                {
                    ...offer.wh_product,
                    virtual_offer_price: offer.offer_price,
                },
            ]
        },

        /**
         *
         */
        response(response) {
            switch (response.status) {
                case 'error':
                    this.showSnackbar(
                        'error',
                        'Error',
                        response.errors || response.error || response.message
                    )
                    break
                case 'success':
                    this.showSnackbar(
                        'success',
                        'Éxito',
                        'Oferta creada con éxito.'
                    )
                    this.$router.push('/offer')
                    break
            }
        },

        /**
         *
         */
        showSnackbar(color, title, message) {
            this.resetSnackbarState()
            this.initSnackbar(
                this.fillSnack(color, title, message, false, 3000)
            )
        },

        /**
         *
         */
        async submit(event) {
            this.response(
                await OfferService.update(this.$route.params.id, {
                    ...event,
                    products: this.products.map(this.mapProduct),
                })
            )
        },
    },
    async mounted() {
        this.reset()
        this.setTitleTopBar('Detalle oferta')
    },
    watch: {
        /**
         *
         */
        products() {
            this.service = {
                dtFetchData: () => ({
                    data: this.products,
                }),
            }
        },
    },
}
</script>
